module.exports = __webpack_public_path__ + "media/stadium-fins.55a5ca25.mp4";